export default __webpack_public_path__ + "static/media/checkbox_off.6434f6df.svg";